import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

export const headerHeight = 60;

const classNames = {
  centerContainer: `HeaderCenterContainer`,
  filter: `HeaderFilter`,
  logo: `HeaderLogo`,
  logoText: `HeaderLogoText`,
  root: `Header`,
  settings: `HeaderSettings`,
  spacer: `HeaderSpacer`
};

export function useHeaderStyles() {
  const {
    semanticColors, spacing, effects, fonts
  } = useTheme();

  const styles = useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          height: `100%`
        }
      ],
      logo: [
        classNames.logo,
        {
          alignItems: `center`,
          display: `flex`,
          height: `calc(100% - (${spacing.s2} * 2))`,
          marginBottom: spacing.s2,
          marginTop: spacing.s2,
          width: 115
        }
      ],
      logoText: [
        classNames.logoText,
        {
          alignItems: `center`,
          display: `flex`,
          height: `calc(100% - (${spacing.s2} * 2))`,
          marginBottom: spacing.s2,
          marginTop: spacing.s2,
          "& span": {
            marginBottom: spacing.s2
          }
        }
      ],
      filter: [
        classNames.filter,
        {
          overflow: `hidden`,
          textAlign: `end`,
          width: `515px`,
          "& .ms-Button:not(:last-child)": {
            width: `auto`
          }
        }
      ],
      settings: [
        classNames.settings,
        {
          paddingBottom: `8px`,
          "& .ms-Button-icon": {
            color: semanticColors.buttonText,
            font: fonts.mediumPlus
          },
          "& .ms-Button-icon:hover": {
            color: semanticColors.buttonTextHovered
          }
        }
      ],
      headerSpacer: [
        classNames.spacer,
        {
          height: headerHeight
        }
      ]
    }),
    [semanticColors, spacing, fonts]
  );

  const centerStyles = useMemo(
    () => mergeStyleSets({
      centerContainer: [
        classNames.centerContainer,
        {
          backgroundColor: semanticColors.bodyBackground,
          boxShadow: effects.elevation8,
          color: semanticColors.bodyText,
          height: headerHeight,
          left: 0,
          position: `absolute`,
          right: 0,
          top: 0,
          zIndex: 10000
        }
      ]
    }),
    [effects, semanticColors]
  );

  return {
    styles,
    centerStyles
  };
}
